module.exports = __webpack_public_path__ + "img/coex.56a27e0c.svg";